export const FdsBridgeKey = 'FDS_BRIDGE_KEY'

// url 로 사용하기 위해 소문자 적용
export const FDSAction = {
    POPUP: 'POPUP',
    REPLACE: 'REPLACE',
} as const

export type FDSActionType = Constant<typeof FDSAction>

// url 로 사용하기 위해 소문자 적용
export const FdsResult = {
    SUCCESS: 'success',
    FAIL: 'fail',
    KEYPAD_SUCCESS: 'keypadSuccess',
    KEYPAD_FAIL: 'keypadFail',
    ARS_SUCCESS: 'arsSuccess',
    ARS_FAIL: 'arsFail',
} as const

export type FdsResultType = Constant<typeof FdsResult>

export const FdsResultCase = {
    SUCCESS: 'SUCCESS',
    CANCEL: 'CANCEL',
    PASSWORD_CHANGE: 'PASSWORD_CHANGE',
} as const

export type FdsResultCaseType = Constant<typeof FdsResultCase>
